/** Chips de partie : chrono, coups vs par, score total. */
import { state } from '../state';
import { totalScore } from '../score';

export function updateMeta(won: boolean): void {
  const p = state.puz;
  const el = document.getElementById('playMeta');
  if (!p || state.screen !== 'play') {
    if (el) el.textContent = '';
    return;
  }
  if (won && p._ft == null) p._ft = Math.max(0, Date.now() - (p.t0 ?? Date.now()));
  const ms = won ? (p._ft ?? 0) : Math.max(0, Date.now() - (p.t0 ?? Date.now()));
  const m = Math.floor(ms / 60000);
  const s = Math.floor(ms / 1000) % 60;
  const mv = p.mv ?? 0;
  const over = !!p.par && mv > p.par * 1.5; // pression lisible, sans punition
  if (el) {
    el.innerHTML =
      `<span class="mchip">⏱ ${m}:${String(s).padStart(2, '0')}</span>` +
      `<span class="mchip${over ? ' over' : ''}">👆 ${mv}${p.par ? ` / par ${p.par}` : ''}</span>` +
      `<span class="mchip score">🏆 <b>${totalScore()}</b></span>`;
  }
}
